import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import ChatbotWidget from "@/components/ChatbotWidget";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  // Reveal-on-scroll observer — also watches for late-added .reveal nodes
  // (async catalog fetch, dynamically inserted sections, etc.).
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const seen = new WeakSet();
    const observe = (root) => {
      const nodes = root.querySelectorAll ? root.querySelectorAll(".reveal") : [];
      nodes.forEach((el) => {
        if (!seen.has(el)) {
          seen.add(el);
          io.observe(el);
        }
      });
    };
    observe(document);
    // Fallback re-observation in case initial render happens after mount
    const timers = [
      setTimeout(() => observe(document), 100),
      setTimeout(() => observe(document), 500),
    ];
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains("reveal") && !seen.has(n)) {
            seen.add(n);
            io.observe(n);
          }
          observe(n);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); timers.forEach(clearTimeout); };
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main className="pt-20" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <div className="lg:hidden h-24" aria-hidden="true" />
      <StickyCTA />
      <ChatbotWidget />
      <PWAInstallPrompt />
    </div>
  );
}
